import React from 'react';

import classes from 'components/widgets/PrioritiesMatrix/components/Matrix/Matrix.module.scss';
import { MatrixBox } from 'components/widgets/PrioritiesMatrix/components/Matrix/components/MatrixBox/MatrixBox';

export const Matrix = ({ buttons, handleMatrixButtonClick, selected }) => {
    return (
        <div className={classes.matrix}>
            {/* Row 1: Header row */}
            <div className={classes.cornerSpacer} />
            <div className={classes.columnHeader}>Urgent</div>
            <div className={classes.columnHeader}>Not Urgent</div>

            {/* Row 2: ImportantFilter row */}
            <div className={classes.rowHeader}>
                <span>Important</span>
            </div>
            <div key={buttons.doNowComponent.title} className={`${classes.linksBox} ${classes.doNow}`}>
                <MatrixBox
                    buttons={buttons.doNowComponent}
                    type={'doNowComponent'}
                    setSelected={handleMatrixButtonClick}
                    selected={selected}
                    number={1}
                />
            </div>
            <div key={buttons.doNextComponent.title} className={`${classes.linksBox} ${classes.doNext}`}>
                <MatrixBox
                    buttons={buttons.doNextComponent}
                    type={'doNextComponent'}
                    setSelected={handleMatrixButtonClick}
                    selected={selected}
                    number={2}
                />
            </div>

            {/* Row 3: Not ImportantFilter row */}
            <div className={classes.rowHeader}>
                <span>Not Important</span>
            </div>
            <div key={buttons.prioritizeComponent.title} className={`${classes.linksBox} ${classes.prioritize}`}>
                <MatrixBox
                    buttons={buttons.prioritizeComponent}
                    type={'prioritizeComponent'}
                    setSelected={handleMatrixButtonClick}
                    selected={selected}
                    number={3}
                />
            </div>
            <div key={buttons.laterComponent.title} className={`${classes.linksBox} ${classes.later}`}>
                <MatrixBox
                    buttons={buttons.laterComponent}
                    type={'laterComponent'}
                    setSelected={handleMatrixButtonClick}
                    selected={selected}
                    number={4}
                />
            </div>
        </div>
    );
};
